import { render, staticRenderFns } from "./ObservationSupport.vue?vue&type=template&id=3f5a90dc&scoped=true&"
import script from "./ObservationSupport.vue?vue&type=script&lang=js&"
export * from "./ObservationSupport.vue?vue&type=script&lang=js&"
import style0 from "./ObservationSupport.vue?vue&type=style&index=0&id=3f5a90dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5a90dc",
  null
  
)

export default component.exports